import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // scan qr
  isLoading: false,
  error: null,
  qrData: null,

  // validate mobile
  validateMobileLoading: false,
  validateMobileError: null,
  validateMobileData: null,

  // claim reward
  claimRewardLoading: false,
  claimRewardError: null,
  claimRewardData: null,

  // GET /claims/:mobile/:claimId (scan flow) — full API envelope for detail screen
  claimStatusFetchLoading: false,
  claimFetchStatus: null,
  claimStatusFetchError: null,
  claimStatusDetail: null,
};

const campgainSlice = createSlice({
  name: 'campgain',
  initialState,
  reducers: {
    // ---------------- SCAN QR ----------------
    scanQrRequest(state) {
      state.isLoading = true;
      state.error = null;
      state.successMessage = null;
    },

    scanQrSuccess(state, action) {
      state.isLoading = false;
      state.qrData = action.payload;
      state.error = null;
      state.successMessage = action.payload?.meta?.message || 'QR scanned successfully';
    },

    scanQrFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.successMessage = null;
    },

    clearQrData(state) {
      state.qrData = null;
      state.error = null;
      state.isLoading = false;
    },

    // ---------------- VALIDATE MOBILE ----------------
    validateMobileRequest(state) {
      state.validateMobileLoading = true;
      state.validateMobileError = null;
      state.validateMobileData = null;
    },

    validateMobileSuccess(state, action) {
      state.validateMobileLoading = false;
      state.validateMobileData = action.payload;
      state.validateMobileError = null;
    },

    validateMobileFailure(state, action) {
      state.validateMobileLoading = false;
      state.validateMobileError = action.payload;
    },

    clearValidateMobile(state) {
      state.validateMobileLoading = false;
      state.validateMobileError = null;
      state.validateMobileData = null;
    },

    // ---------------- CLAIM REWARD ----------------
    claimRewardRequest(state) {
      state.claimRewardLoading = true;
      state.claimRewardError = null;
      state.claimRewardData = null;
    },

    claimRewardSuccess(state, action) {
      state.claimRewardLoading = false;
      state.claimRewardData = action.payload;
      state.claimRewardError = null;
    },

    claimRewardFailure(state, action) {
      state.claimRewardLoading = false;
      state.claimRewardError = action.payload;
    },

    clearClaimReward(state) {
      state.claimRewardLoading = false;
      state.claimRewardError = null;
      state.claimRewardData = null;
    },

    claimStatusFetchRequest(state) {
      state.claimStatusFetchLoading = true;
      state.claimStatusFetchError = null;
      state.claimStatusDetail = null;
    },

    claimStatusFetchSuccess(state, action) {
      state.claimStatusFetchLoading = false;
      state.claimStatusFetchError = null;
      const p = action.payload || {};
      state.claimStatusDetail = {
        meta: p.meta ?? null,
        data: p.data ?? null,
      };
      const claims = p.data?.claims;
      const first = Array.isArray(claims) ? claims[0] : null;
      state.claimFetchStatus = first?.status != null && first.status !== '' ? String(first.status) : null;
    },

    claimStatusFetchFailure(state, action) {
      state.claimStatusFetchLoading = false;
      state.claimStatusFetchError = action.payload ?? 'Failed to load claim status';
    },

    clearClaimStatusFetch(state) {
      state.claimStatusFetchLoading = false;
      state.claimFetchStatus = null;
      state.claimStatusFetchError = null;
      state.claimStatusDetail = null;
    },

    clearClaimStatusFetchError(state) {
      state.claimStatusFetchError = null;
    },
  },
});

export const {
  // scan qr
  scanQrRequest,
  scanQrSuccess,
  scanQrFailure,
  clearQrData,

  // validate mobile
  validateMobileRequest,
  validateMobileSuccess,
  validateMobileFailure,
  clearValidateMobile,

  // claim reward
  claimRewardRequest,
  claimRewardSuccess,
  claimRewardFailure,
  clearClaimReward,

  claimStatusFetchRequest,
  claimStatusFetchSuccess,
  claimStatusFetchFailure,
  clearClaimStatusFetch,
  clearClaimStatusFetchError,
} = campgainSlice.actions;

export default campgainSlice.reducer;
